import {LockIcon, PeopleIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, FormControl} from '@primer/react'
import {useId} from 'react'

import {LABELS} from '../../constants'
import type {SavedViewVisibility} from '../../types'

const OPTIONS = [
  {
    value: 'personal',
    label: LABELS.views.personal,
    description: LABELS.views.visibilityPersonalDescription,
    icon: LockIcon,
  },
  {value: 'team', label: LABELS.views.team, description: LABELS.views.visibilityTeamDescription, icon: PeopleIcon},
] as const satisfies ReadonlyArray<{
  value: SavedViewVisibility
  label: string
  description: string
  icon: typeof LockIcon
}>

export function VisibilitySelect({
  value,
  onChange,
}: {
  value: SavedViewVisibility
  onChange: (value: SavedViewVisibility) => void
}) {
  const selected = OPTIONS.find(option => option.value === value) ?? OPTIONS[0]
  const SelectedIcon = selected.icon
  const buttonId = useId()

  return (
    <FormControl>
      <FormControl.Label htmlFor={buttonId}>{LABELS.views.visibility}</FormControl.Label>
      <ActionMenu>
        <ActionMenu.Button
          id={buttonId}
          leadingVisual={SelectedIcon}
          aria-label={`${LABELS.views.visibility}: ${selected.label}`}
        >
          {selected.label}
        </ActionMenu.Button>
        <ActionMenu.Overlay align="end">
          <ActionList selectionVariant="single">
            {OPTIONS.map(option => (
              <ActionList.Item
                key={option.value}
                selected={option.value === value}
                onSelect={() => onChange(option.value)}
              >
                <ActionList.LeadingVisual>
                  <option.icon />
                </ActionList.LeadingVisual>
                {option.label}
                <ActionList.Description variant="block">{option.description}</ActionList.Description>
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </FormControl>
  )
}
